<template>
  <div class="box box_mm">
    <div class="box_main">
      <search
        @search="search"
        @reset="reset"
        :hiddensshy="true"
        ref="mysearch"
        url="/api/proposa/index"
        :hiddentype="true"
      >
      </search>
      <div class="box_cont">
        <div class="btn_list">
          <!-- <el-button type="primary" @click="goaddnew">新增</el-button> -->
        </div>
        <div style="height: 76vh; box-sizing: border-box">
          <MyTable
            ref="zjlist"
            :tableData="tableData"
            :tableHeader="tableHeader"
            :showselect="selecthe"
            :showbm="true"
            :czwidth="460"
            @getdata="gettable"
            @selectdata="selectdata"
            @lookhb="lookhb"
          >
            <template slot="btns" slot-scope="{ scope }">
              <el-button @click="look(scope.row)" type="success" size="mini"
                >详情</el-button
              >
            </template>
          </MyTable>
        </div>
      </div>
    </div>

    <!--详情-->
    <mydetail
      v-if="showdetail"
      :id="detail_id"
      :showdy="true"
      requsturl="/api/proposa/details"
      @closedetail="showdetail = false"
    >
      <div slot="otherbtn" style="display: flex; flex-direction: column"></div>
    </mydetail>

    <!--承办单位列表-->
    <cbdwtc ref="mycbdwtc"></cbdwtc>

    <!--查看合并提案-->
    <lookhb ref="mylookhb"></lookhb>

    <selectcbdw ref="myselectcbdw" @selectedry="selecteddw"></selectcbdw>
  </div>
</template>

<script>
import selectcbdw from "@/components/select_cbdw.vue";
import mydetail from "@/components/detail_tc.vue";
import cbdwtc from "../list/component/cbdw_list.vue";
import lookhb from "../list/component/lookhb.vue";
import search from "../component/search";
export default {
  components: {
    mydetail,
    cbdwtc,
    lookhb,
    selectcbdw,
    search,
  },
  data() {
    return {
      showdetail: false,
      detail_id: "",
      searchinput: "",
      tableHeader: [
        {
          name: "立案号",
          prop: "lacode",
          width: "80",
        },
        {
          name: "流水号",
          prop: "lscode",
          width: "80",
        },
        {
          name: "标题",
          prop: "name",
          width: "300",
        },
        {
          name: "提案类别",
          prop: "lei_name",
          width: "",
        },
        {
          name: "办理单位",
          prop: "bltw",
          width: "240",
        },
        {
          name: "提交人",
          prop: "user_name",
          width: "",
        },
        {
          name: "提交时间",
          prop: "addtime",
          width: "150",
        },
        {
          name: "状态",
          prop: "type",
          width: "120",
          type: "tags",
        },
        {
          name: "处理异议",
          prop: "type",
          width: "120",
          type: "tags_yy",
        },
      ],
      tableData: [],
      rowdata: "",
      lianshow: false,
      czid: "", //当前操作的数据id

      danwei: [],
      taleix: [], //提案类型
      selecttype: "", //转意见 交办使用
      showyy: false,
      yylist: [],

      selecthe: false, //选择提案合并
      options: [], //已选合并 数据
      selectza: "", //已选合并主案id
      showhb: false,

      //设置督办相关
      showdb: false,
      loading: false,
      zhuanren: "",
      userlist: [],
      db_id: "",

      iii: 0,
    };
  },
  mounted() {
    this.$refs.mysearch.searchstatus = "2,4,5,6,7";
    this.$refs.mysearch.searyjstype = "2";

    this.gettable();

    //获取承办单位数据
    this.$post({
      url: "/api/organizational/index",
      params: {
        p: 1,
        size: 9999,
        pid: 3,
      },
    }).then((res) => {
      this.danwei = res.list;
    });
    //获取提案类型
    this.$post({
      url: "/api/lei/index",
      params: {
        p: 1,
        size: 9999,
      },
    }).then((res) => {
      this.taleix = res.list;
    });
  },
  activated() {
    this.gettable(); // 每次进入页面时刷新数据
  },
  methods: {
    selecteddw(e) {},
    edit(row) {
      this.$router.push("/system/edit_tian?id=" + row.id);
    },
    qrdb() {
      this.$post({
        url: "/api/proposa/qtcz",
        params: {
          ids: this.db_id,
          dbuser: this.zhuanren,
          zddbta: 2,
        },
      }).then((res) => {
        this.closedb();
        this.$message.success("操作成功");
        this.gettable();
      });
    },
    closedb() {
      this.zhuanren = "";
      this.db_id = "";
      this.showdb = false;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        //获取提案类型
        this.$post({
          url: "/api/user/index",
          params: {
            name: query,
            p: 1,
            size: 9999,
          },
        }).then((res) => {
          this.loading = false;
          this.userlist = res.list;
        });
      } else {
        this.userlist = [];
      }
    },
    handleCommand(e) {
      console.log(e);
      //e.type== a 推荐重大提案   b推荐重点督办提案   c设为回头看项目
      if (e.type == "b") {
        this.db_id = e.id;
        this.showdb = true;
        return;
      }
      let obj = {
        ids: e.id,
      };
      if (e.type == "a") {
        obj.zzdta = 2;
      }
      if (e.type == "c") {
        obj.htk = 2;
      }
      this.$post({
        url: "/api/proposa/qtcz",
        params: obj,
      }).then((res) => {
        this.$message.success("操作成功");
        this.gettable();
      });
    },

    lookhb(item) {
      console.log(item);
      this.$post({
        url: "/api/proposa/hbindex",
        params: {
          id: item.id,
        },
      }).then((res) => {
        this.$refs.mylookhb.tableData = res.list;
        this.$refs.mylookhb.showyy = true;
      });
    },
    look(item) {
      this.rowdata = item;
      this.detail_id = item.id;
      this.showdetail = true;
    },
    goaddnew() {
      this.$router.push("/system/add_zhengji");
    },
    addnew() {
      this.$router.push("/system/swiper_add");
    },
    reset() {
      this.$refs.mysearch.searchinput = "";
      this.$refs.mysearch.searchlei = "";
      this.$refs.mysearch.searchsshy = "";
      this.$refs.mysearch.searchhb = "";
      this.$refs.mysearch.searchstatusvalue = "";
      this.$refs.mysearch.searchstatus = "2,4,5,6,7";
      this.$refs.mysearch.searyjstype = "2";
      this.$refs.mysearch.searchbldw = "";
      this.$refs.zjlist.inputpage = 1;
      this.gettable();
    },
    search() {
      this.$refs.zjlist.inputpage = 1;
      this.gettable();
    },
    gettable() {
      this.$post({
        url: "/api/proposa/index",
        params: {
          p: this.$refs.zjlist.inputpage,
          size: this.$refs.zjlist.pagesize,
          name: this.$refs.mysearch.searchinput,
          lei_id: this.$refs.mysearch.searchlei,
          sshy: this.$refs.mysearch.searchsshy,
          hidtype: this.$refs.mysearch.searchhb,
          blusers: this.$refs.mysearch.searchbldw,
          type: "",
          jstype: "2",
          yjtype: 2,
        },
      }).then((res) => {
        this.tableData = res.list;
        this.$refs.zjlist.total = res.count;

        //回显打勾
        let selectedlist = [];
        res.list.forEach((item, index) => {
          if (item.xuan != 1) {
            selectedlist.push(item);
          }
        });
        this.$refs.zjlist.toggleSelection(selectedlist);
      });
    },
    deleterow(row) {
      this.$confirm("确认删除该条数据吗？")
        .then((_) => {
          this.$post({
            url: "/admin/banner/delete",
            params: {
              id: row.id,
            },
          }).then((res) => {
            this.$message.success("删除成功");
            this.gettable();
          });
        })
        .catch((_) => {});
    },
    showsetrole(row) {
      console.log(row);
      this.$refs.mymx.showmx = true;
    },
    changswitch(row) {
      console.log(row);
    },
  },
};
</script>

<style lang="scss" scoped>
.box_main {
  background-color: #fff;
  padding: 15px 25px;
  width: 100%;
  box-sizing: border-box;
  min-height: 100%;
}

.search_box {
  display: flex;
  align-items: center;
  font-size: 0.16rem;

  .search_item {
    display: flex;
    align-items: center;
    margin-right: 0.8rem;
  }
}

.box_cont {
  margin-top: 20px;
}

.btn_list {
  display: flex;
  align-items: center;
}

.tc_title {
  font-size: 0.18rem;
  font-weight: bold;
  color: #333;
  position: relative;
  padding-left: 20px;
  margin-bottom: 20px;
}

.tc_title:after {
  content: "";
  position: absolute;
  height: 100%;
  width: 4px;
  left: 0px;
  background-color: rgb(26, 144, 253);
}

::v-deep td {
  text-align: center !important;
}

::v-deep .el-table th.el-table__cell > .cell {
  text-align: center !important;
}

::v-deep .el-table th.el-table__cell.is-leaf {
  background-color: rgb(242, 242, 242);
  color: #777;
}

::v-deep .el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
}

::v-deep .el-table td.el-table__cell {
}

::v-deep .el-table {
  margin-top: 10px;
}

::v-deep .el-table__fixed {
}

::v-deep .el-table::before {
  background-color: #fff !important;
}

::v-deep .el-table__fixed::before {
  background-color: #fff !important;
}

::v-deep .el-dialog__header {
  display: flex !important;
}

::v-deep .el-dialog__footer span {
  display: flex !important;
  justify-content: space-around;
  width: 100%;
}
</style>
